import React from 'react';
import { LivretEvalShare } from './Livrets/LivretEvalShare';
import { LivretEvalShareWrapper } from 'containers/Livrets/LivretEvalShare/Wrapper';
import { LivretEleveShare } from 'containers/Livrets/LivretEvalShare/LivretEleveShare';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { CJShare, CJShareWrapper } from 'containers/CahierJournal/CJShare';
import { RedirectToCurrentDay } from './CahierJournal/RedirectToCurrentDay';
import { EDTShareWrapper } from 'containers/EmploiDuTemps/EDT/EDTShare';
import { ProgV2ShareWrapper } from './Programmations/ProgV2/Share';
import CarnetShareWrapper from './CarnetsDeNotes/Shares/Loadable';
import { EvaluationForm } from 'containers/CarnetsDeNotes/Evaluations/EvaluationForm';
import { useEvaluations } from 'containers/CarnetsDeNotes/queries/evaluations/useEvaluations';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import { useCDNContext } from 'containers/CarnetsDeNotes/CarnetDeNotesContext';
import EvaluationsRoot from 'containers/CarnetsDeNotes/Evaluations/Loadable';
import { PreviewCJShare } from 'containers/CahierJournal/CJShare/PreviewCJShare';

export function RedirectToAnotherEvaluation() {
  const { cdnId, getEvaluationLink } = useCDNContext();
  const { data, isLoading, isFetched } = useEvaluations(cdnId);

  if (isLoading || !isFetched || !data) {
    return <SpinnerComponent />;
  }
  if ((data || []).length === 0 || !getEvaluationLink) {
    return null;
  }

  return <Navigate to={getEvaluationLink(cdnId, data[0].id)} />;
}

function SetShareInfoInLocalStorage() {
  const params = useParams<{
    token: string;
    userId: string;
  }>();
  const userId = params.userId as string;
  const token = params.token as string;

  (window as any).shareToken = `ShareToken ${btoa(`${userId}:${token}`)}`;
  return <Outlet />;
}

export const ShareRoutes = {
  path: 'shares/:userId/t/:token',
  element: <SetShareInfoInLocalStorage />,
  children: [
    {
      path: 'carnets-de-notes',
      element: <CarnetShareWrapper />,
      children: [
        {
          index: true,
          element: <Navigate to="evaluations" />,
        },
        {
          path: 'evaluations',
          element: <EvaluationsRoot />,
          children: [
            {
              path: ':evaluationId',
              element: <EvaluationForm />,
            },
            {
              index: true,
              element: <RedirectToAnotherEvaluation />,
            },
          ],
        },
      ],
    },
    {
      path: 'livrets',
      element: <LivretEvalShareWrapper />,
      children: [
        {
          path: 'eleves/:eleveId',
          element: <LivretEleveShare />,
        },
        {
          index: true,
          element: <LivretEvalShare />,
        },
      ],
    },
    {
      path: 'cahier-journal',
      element: <CJShareWrapper />,
      children: [
        {
          path: ':view/:year/:month/:day',
          children: [
            {
              path: 'preview',
              element: <PreviewCJShare />,
            },
            {
              index: true,
              element: <CJShare />,
            },
          ],
        },
        {
          index: true,
          element: <RedirectToCurrentDay />,
        },
      ],
    },
    {
      path: 'emploi-du-temps',
      element: <EDTShareWrapper />,
    },
    {
      path: 'programmation',
      element: <ProgV2ShareWrapper />,
    },
  ],
};
